<tui-loader [loading]="loading()" [overlay]="true">
	<section tuiContent>
		<form [formGroup]="form" class="flex flex-col gap-4">
			<label tuiLabel>
				<input
					tuiSwitch
					size="s"
					type="checkbox"
					formControlName="systemNotifications"
				/>
				<span tuiTitle>
					{{
						'analyses.dialog.settings.notifications.title'
							| transloco
					}}
					<span tuiSubtitle>
						{{
							'analyses.dialog.settings.notifications.description'
								| transloco
						}}
					</span>
				</span>
			</label>
		</form>
	</section>

	<footer tuiFooter>
		<button
			tuiButton
			size="s"
			type="button"
			appearance="outline"
			[disabled]="saving()"
			(click)="onDismiss()"
		>
			{{ 'action.cancel' | transloco }}
		</button>
		<button
			tuiButton
			size="s"
			type="button"
			[loading]="saving()"
			[disabled]="loading() || saving()"
			(click)="onSave()"
		>
			{{ 'action.save' | transloco }}
		</button>
	</footer>
</tui-loader>
